module.exports = __webpack_public_path__ + "static/media/icon_channel_multishow.0cf1257b.svg";